/**
 * 서버 실행 시, 자동으로 생성된 page path routes 모음 파일입니다.
 * 커밋에 누락되지 않도록 꼭 추가해주세요.
 * pnpm run prettier:fix를 통해 lint를 맞춰주세요.
 */
export const INTERNAL_ROUTES = {
    'BANK_[ID]_DEPOSIT': '/bank/[id]/deposit',
    'BANK_[ID]_FUND_[STATEMENTID]': '/bank/[id]/fund/[statementId]',
    'BANK_[ID]_FUND': '/bank/[id]/fund',
    'BANK_[ID]': '/bank/[id]',
    'BANK_[ID]_ISA': '/bank/[id]/isa',
    'BANK_[ID]_SCHEDULED': '/bank/[id]/scheduled',
    'BANK_[ID]_SIMPLEPAY': '/bank/[id]/simplepay',
    BANK_EMPTY: '/bank/empty',
    BANK_ESTIMATE: '/bank/estimate',
    BANK: '/bank',
    BANK_UNUSED: '/bank/unused',
    BRIDGE_PAY_APP_AUTH_ERROR: '/bridge/pay-app-auth-error',
    'CARD_APPROVAL_[ASSETID]_[APPROVALID]': '/card/approval/[assetId]/[approvalId]',
    'CARD_APPROVAL_[ASSETID]': '/card/approval/[assetId]',
    'CARD_APPROVAL_GOAL_[ASSETID]_CONFIRM': '/card/approval/goal/[assetId]/confirm',
    'CARD_APPROVAL_GOAL_[ASSETID]': '/card/approval/goal/[assetId]',
    CARD_APPROVAL: '/card/approval',
    'CARD_BILL_[BILLID]_[BILLDETAILID]': '/card/bill/[billId]/[billDetailId]',
    'CARD_BILL_[BILLID]': '/card/bill/[billId]',
    CARD_BILL: '/card/bill',
    CARD_EMPTY: '/card/empty',
    'CARD_INFO_[ASSETID]': '/card/info/[assetId]',
    'CARD_PAYMENT_[PAYMENTID]': '/card/payment/[paymentId]',
    CARD_POINT: '/card/point',
    'CARD_REVOLVING_[ORGCODE]': '/card/revolving/[orgCode]',
    CARD_SETTING: '/card/setting',
    'EFIN_[ASSETID]_SCHEDULED': '/efin/[assetId]/scheduled',
    'EFIN_CORP_[ORGCODE]': '/efin/corp/[orgCode]',
    EFIN_EMPTY: '/efin/empty',
    EFIN: '/efin',
    'EFIN_STATEMENT_[ASSETID]_[ASSETTYPE]_[STATEMENTID]': '/efin/statement/[assetId]/[assetType]/[statementId]',
    ROOT: '/',
    'INSURANCE_CONTENTS_[ID]': '/insurance/contents/[id]',
    'INSURANCE_CONTENTS_CATEGORY_[CATEGORY]': '/insurance/contents/category/[category]',
    INSURANCE_CONTENTS: '/insurance/contents',
    INSURANCE_CONTENTS_SEARCH: '/insurance/contents/search',
    'INSURANCE_MY_[ID]_CAR_[CARID]': '/insurance/my/[id]/car/[carId]',
    'INSURANCE_MY_[ID]_FREE_[INSURANCEID]': '/insurance/my/[id]/free/[insuranceId]',
    'INSURANCE_MY_[ID]_GENERAL': '/insurance/my/[id]/general',
    'INSURANCE_MY_[ID]_GUARANTEE': '/insurance/my/[id]/guarantee',
    'INSURANCE_MY_[ID]_STATEMENTS': '/insurance/my/[id]/statements',
    INSURANCE_MY_AGREEMENT: '/insurance/my/agreement',
    'INSURANCE_MY_COVERAGES_[TYPE]': '/insurance/my/coverages/[type]',
    INSURANCE_MY_COVERAGES: '/insurance/my/coverages',
    INSURANCE_MY_EXPIRED: '/insurance/my/expired',
    INSURANCE_MY_HOME_DIAGNOSIS: '/insurance/my/home/diagnosis',
    INSURANCE_MY_HOME: '/insurance/my/home',
}
